/**
 * @author Lucas Fridez <lucas@fridez.dev>
 * @client Gigon SA
 * @project webapp-scan
 * @file src\app\framework\user\UserProfile.ts
 * @copyright 2018 Lucas Fridez
 */

export enum UserProfile_e {
    AGENCY_MANAGER = 1,
    FITTER = 2,
    ADMIN = 3
}



// WEBPACK FOOTER //
// ./src/app/framework/user/UserProfile.ts